import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "db424689-97df-42ef-8281-7bc43f92e782", content: "Moving mass", options: {} },
  { id: "e94180a5-6ab8-4aba-a920-ea196c4c70ce", content: "Coil inductance", options: {} },
  { id: "87a3efd7-2986-482a-ae83-50f85b021e22", content: "Suspension compliance", options: {} },
  { id: "fd44b220-f57e-4e3d-86a4-96d60dd6d48d", content: "Coil resistance", options: {} },
  { id: "a96dc160-8c54-4e1c-9221-9a3a87f55604", content: "Mechanical losses", options: {} },
  { id: "c44b55c9-9a5b-4b9e-9465-273c654f65d3", content: "Coil length", options: {} },
];

export const task: Task = {
  id: "e1d0b5c7-30f5-4f1c-8ed7-ea692a7e4cf9",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "db424689-97df-42ef-8281-7bc43f92e782",
    "fd44b220-f57e-4e3d-86a4-96d60dd6d48d",
    "c44b55c9-9a5b-4b9e-9465-273c654f65d3",
  ],
};
